import { combineReducers } from '@reduxjs/toolkit';
import auth from '@ameroservices-platform/shipfromstore-flexposui/app/auth/store';
import fuse from './fuse';
import i18n from './i18nSlice';
import shared from './shared';
import shippingSlice from '@ameroservices-platform/shipfromstore-flexposui/app/main/apps/flexposShipping/store/shippingSlice';

const createReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		auth,
		fuse,
		i18n,
		shippingSlice,
		shared,
		...asyncReducers,
	});

	/*
	Reset the redux store when user logged out
	 */
	if (action.type === 'auth/user/userLoggedOut') {
		// state = undefined;
	}

	return combinedReducer(state, action);
};

export default createReducer;
